export default class NewsAudioPlayer {
  constructor(args) {
    this.container = document.querySelector('#news-audio-player');
    if (!this.container) return;

    this.playerElement = document.querySelector('#news-audio-player audio');
    this.player = null;
    this.hasDownloadOption = this.container.hasAttribute('download');

    this.initPlayer();
    this.addEvents();
  }

  initPlayer() {
    this.player = new Plyr(this.playerElement, {
      disableContextMenu: true,
      invertTime: false,
      controls: [
        ...[
          'play', // Play/pause playback
          'progress', // The progress bar and scrubber for playback and buffering
          'current-time', // The current time of playback
          'volume', // Volume control
        ],
        ...(this.hasDownloadOption ? [
          'download' // Show a download button with a link to either the current source or a custom URL you specify in your options
        ] : [])
      ]
    });
  }

  addEvents() {
    this.player.on('ready', e => {
      this.container.classList.remove('hide');
    });
  }
}